module.exports = __webpack_public_path__ + "img/Rectangle Copy 6@2x.e63c34f3.png";